import { render, staticRenderFns } from "./dataBoard.vue?vue&type=template&id=68e5410e&scoped=true&"
import script from "./dataBoard.vue?vue&type=script&lang=js&"
export * from "./dataBoard.vue?vue&type=script&lang=js&"
import style0 from "./dataBoard.vue?vue&type=style&index=0&id=68e5410e&lang=less&scoped=true&"
import style1 from "./dataBoard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e5410e",
  null
  
)

export default component.exports